import { useTranslation } from "react-i18next";

import { LegalDocumentScreen } from "@/components/legal/legal-document-screen";
import { getLegalDocumentWithFallback } from "@/i18n/legal";

export default function PrivacyPolicyScreen() {
  const { i18n } = useTranslation();
  return (
    <LegalDocumentScreen
      content={getLegalDocumentWithFallback("privacy", i18n.language)}
    />
  );
}
